import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HelpTicket } from '@shared/models/help-ticket.model';
import { environment } from '@env/environment';

@Component({
  selector: 'miq-ticket-detail-info',
  templateUrl: './ticket-detail-info.component.html',
  styleUrls: ['./ticket-detail-info.component.scss'],
  standalone: false,
})
export class TicketDetailInfoComponent implements OnInit {
  @Input() public ticketDetail: HelpTicket;
  public ticketDesc = '';
  public ticketWebLink: SafeUrl;
  public miqUrl: string;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.splitTicketDescription();
  }

  splitTicketDescription() {
    const splitURL = this.ticketDetail.desc.split('url:');
    if (this.ticketDetail.desc && splitURL.length) {
      this.ticketDesc = splitURL[0];
      if (splitURL.length > 1) {
        this.miqUrl = splitURL[1];
        this.ticketWebLink = this.sanitizer.sanitize(SecurityContext.URL, `${environment.host}${this.miqUrl}`);
      }
    }
  }
}
